<template>
  <Loader :show="loading" v-if="loading"></Loader>
  <MDBRow v-else-if="files.length">
    <FileItemPrivate v-for="(file, i) in files" :key="i" :file="file" />
  </MDBRow>
</template>

<script setup>
import Loader from "@/components/General/Loader/index";
import { MDBRow } from "mdb-vue-ui-kit";
import FileItemPrivate from "@/components/ProductInfo/FileItemPrivate.vue";

import { useStore } from "vuex";
import { computed, onMounted } from "vue";

const store = useStore();
const loading = computed(() => store.getters.getPending);

const fetchPrices = async () => {
  try {
    await store.dispatch("loadPrices");
  } catch (error) {
    console.log(error);
  }
};

onMounted(() => {
  fetchPrices();
});

const currentLocale = computed(() => store.getters.getCurrentLocale);
const files = computed(() =>
  (store.getters.getPrices || []).map(item => ({
    date: item.date,
    extension: item.extension,
    file: item.file[currentLocale.value],
    id: item.id,
    plainId: item.plainId,
    title: item.title?.[currentLocale.value] ?? ""
  }))
);

</script>
